<template>
  <footer class="footer">
    <div class="footer-content">
      <p>&copy; 2026 我爱纪录片 <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">闽ICP备15013618号-3</a></p>
      <div class="social-links">
        <!-- <a href="#" class="social-link" title="微博">
          <i class="fab fa-weibo"></i>
        </a>-->
        <div class="social-link wechat-link">
          <i class="fab fa-weixin"></i>
          <div class="wechat-qrcode">
            <img src="/images/qrcode_for_gh_4292cc7acd18_258.jpg" alt="纪录片狂爱者-微信公众号二维码" />
          </div>
        </div>
        <a href="https://space.bilibili.com/33910191" class="social-link" title="B站">
          <i class="fab fa-bilibili"></i>
        </a>
        <!-- <a href="#" class="social-link" title="抖音">
          <i class="fab fa-tiktok"></i>
        </a> -->
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
// Footer组件逻辑
</script>

<style scoped>
.footer {
  background: var(--gradient-dark);
  color: var(--white);
  text-align: center;
  padding: 40px 20px;
  backdrop-filter: blur(20px);
  position: relative;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: var(--z-base);
}

.footer-content p {
  margin-bottom: 20px;
  opacity: 0.9;
}

.footer-content a {
  color: var(--secondary-color);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-content a:hover {
  color: var(--accent-color);
  text-decoration: underline;
}

.social-links {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

.social-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  color: var(--white);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  text-decoration: none !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.social-link:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-5px) rotate(360deg);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  text-decoration: none !important;
}

.wechat-link {
  position: relative;
  cursor: pointer;
}

.wechat-link:hover {
  transform: none;
}

.wechat-qrcode {
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  visibility: hidden;
}

.wechat-qrcode img {
  width: 150px;
  height: 150px;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
  background: #fff;
  padding: 10px;
}

.wechat-link:hover .wechat-qrcode {
  opacity: 1;
  visibility: visible;
}

@media (max-width: 480px) {
  .footer {
    padding: 30px 15px;
  }

  .social-links {
    gap: 15px;
  }

  .social-link {
    width: 40px;
    height: 40px;
  }
}
</style>